/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _NewInputs */

const en__new = /** @type {(inputs: _NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New`)
};

const fr__new = /** @type {(inputs: _NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau`)
};

const de__new = /** @type {(inputs: _NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neu`)
};

const it__new = /** @type {(inputs: _NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuovo`)
};

const ru__new = /** @type {(inputs: _NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый`)
};

const es__new = /** @type {(inputs: _NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo`)
};

const zh_cn2__new = /** @type {(inputs: _NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新的`)
};

const ja__new = /** @type {(inputs: _NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい`)
};

const hi__new = /** @type {(inputs: _NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया`)
};

const pt_pt2__new = /** @type {(inputs: _NewInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Novo`)
};

/**
* | output |
* | --- |
* | "New" |
*
* @param {_NewInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
const _new = /** @type {((inputs?: _NewInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_NewInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr__new(inputs)
	if (locale === "de") return de__new(inputs)
	if (locale === "it") return it__new(inputs)
	if (locale === "ru") return ru__new(inputs)
	if (locale === "es") return es__new(inputs)
	if (locale === "zh-CN") return zh_cn2__new(inputs)
	if (locale === "ja") return ja__new(inputs)
	if (locale === "hi") return hi__new(inputs)
	if (locale === "pt-PT") return pt_pt2__new(inputs)
	return en__new(inputs)
});
export { _new as "new" }